import { Route, Routes } from "react-router-dom";
import { Error404 } from "./screens/404/Error404";
import { EodIframe } from "./screens/EodIframe";

export const MainContent: React.FC = () => {
  return (
    <Routes>
      <Route path="/:api_key?/:personalization_id?/:lng?" element={<EodIframe />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};
